import { SignIn, SignUp, Show } from "@clerk/react";
import { Navigate } from "react-router-dom";

const HERO = "https://images.unsplash.com/photo-1613031729579-ace1feefda4c?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400";

export default function AuthPage({ mode }) {
  return (
    <div className="min-h-screen flex bg-[#0B0F17]" data-testid="auth-page">
      <Show when="signed-in"><Navigate to="/" replace /></Show>
      <div className="hidden lg:flex lg:w-1/2 relative overflow-hidden">
        <img src={HERO} alt="Mixer audio" className="absolute inset-0 w-full h-full object-cover opacity-50" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0B0F17] via-[#0B0F17]/60 to-transparent" />
        <div className="relative mt-auto p-12 max-w-lg">
          <p className="micro-label text-amber-400">GCAVCOM Srl · Pisa</p>
          <h1 className="text-4xl font-bold tracking-tight mt-3">Preventivi completi in pochi secondi.</h1>
          <p className="text-slate-300 mt-4">Scrivi o detta l'evento, scegli dal listino e i kit: il calcolo con coefficiente √giorni e il PDF per il cliente si compongono da soli.</p>
        </div>
      </div>
      <div className="flex-1 flex items-center justify-center p-4 grid-bg">
        {mode === "in"
          ? <SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp />
          : <SignUp routing="path" path="/sign-up" signInUrl="/sign-in" />}
      </div>
    </div>
  );
}
